import { useRef } from 'react'

import {
  getBirdviewLayoutWithMovedWidget,
  getBirdviewLayoutWithSortedColumn,
  getBirdviewOverColumn,
} from '../../BirdviewLayout.utils'

export function useBirdviewLayoutDrag({ layout, setLayout }) {
  const layoutBeforeDragRef = useRef(null)

  // A cross-column move is applied on drag-over, so a cancelled drag has to
  // restore the layout the drag started from.
  function handleDragStart() {
    layoutBeforeDragRef.current = layout
  }

  function restoreLayoutBeforeDrag() {
    setLayout(prev => layoutBeforeDragRef.current ?? prev)
  }

  function handleDragCancel() {
    restoreLayoutBeforeDrag()

    layoutBeforeDragRef.current = null
  }

  function handleDragOver({ active, over }) {
    const overColumn = getBirdviewOverColumn(over)

    if (overColumn) {
      setLayout(prev =>
        getBirdviewLayoutWithMovedWidget({
          activeId: active.id,
          layout: prev,
          over,
          overColumn,
        })
      )
    }
  }

  function handleDragEnd({ active, over }) {
    const overColumn = getBirdviewOverColumn(over)

    if (overColumn) {
      setLayout(prev =>
        getBirdviewLayoutWithSortedColumn({
          activeId: active.id,
          layout: prev,
          over,
          overColumn,
        })
      )
    } else {
      restoreLayoutBeforeDrag()
    }

    layoutBeforeDragRef.current = null
  }

  return {
    handleDragCancel,
    handleDragEnd,
    handleDragOver,
    handleDragStart,
  }
}
